import {
  SESSION_WHOSE_CHART_FAILS,
  SESSION_WITH_MEASUREMENTS,
  SESSION_WITH_NO_MEASUREMENTS,
} from "../charge-detail-records/stubs";
import { COMPANY_NAMES } from "../shared";

interface MeterDatum {
  meter?: number;
  power: number;
  consumed: number;
  time: string;
}

const SEEDED_METER_DATA: MeterDatum[] = [
  { time: "2026-06-03T06:10:00.000Z", power: 0, consumed: 0, meter: 1_000 },
  { time: "2026-06-03T06:20:00.000Z", power: 22, consumed: 3.6, meter: 1_004 },
  { time: "2026-06-03T06:30:00.000Z", power: 22, consumed: 7.3, meter: 1_007 },
  { time: "2026-06-03T06:40:00.000Z", power: 22, consumed: 7.3, meter: 1_007 },
  { time: "2026-06-03T06:50:00.000Z", power: 43, consumed: 14.5, meter: 1_015 },
  { time: "2026-06-03T07:30:00.000Z", power: 43, consumed: 43.2, meter: 1_043 },
  { time: "2026-06-03T08:30:00.000Z", power: 11, consumed: 61.8, meter: 1_062 },
  { time: "2026-06-03T09:55:00.000Z", power: 0, consumed: 74.1, meter: 1_074 },
];

const SEEDED_CHART_SUMMARY = {
  firstMeter: 1_000,
  lastMeter: 1_074,
  avgPower: 19.8,
  maxPower: 43,
};

const SEEDED_PRIORITY_TRANSACTIONS = [
  { transactionId: 991_001, startedAt: "2026-06-03T07:00:00.000Z" },
  { transactionId: 991_002, startedAt: "2026-06-04T23:00:00.000Z" },
];

const SEEDED_CHARGE_RECORDS: Record<number, Record<string, unknown>> = {
  [SESSION_WITH_MEASUREMENTS.transactionId]: {
    transactionId: SESSION_WITH_MEASUREMENTS.transactionId,
    isCompleted: true,
    startedAt: "2026-06-03T06:10:00.000Z",
    endedAt: "2026-06-03T09:55:00.000Z",
    consumedInWattHours: 74_100,
    tagIdLabel: SESSION_WITH_MEASUREMENTS.tagIdLabel,
    customerName: COMPANY_NAMES.pendingClean,
    location: { id: 4021, name: "Aarhus Nord" },
    consumed: 74.1,
    createdAt: "2026-06-03T06:05:00.000Z",
    sessionId: "4f1c9a20-5f21-4a1e-9b0f-3f2a1b7c8d90",
    isPriority: true,
    duration: { charging: "13500", idle: "0" },
    price: { amount: 182.5, currency: "DKK" },
    meterStart: "1000",
    meterStop: "1074",
    lastMeter: "2026-06-03T09:55:00.000Z",
    maxPower: 43,
    avgPower: 19.8,
    vehicleState: { firstValue: 18, lastValue: 92 },
    co2: 0.012,
    evseId: "DK*SPI*E4021*1",
    operatorName: "Spirii Operator",
    company: { name: COMPANY_NAMES.pendingClean },
    auth: {
      type: "RFID",
      idTag: {
        id: 7714,
        uid: "04A1B2C3D4E5F6",
        operator: { name: "Spirii" },
      },
    },
    roamingDetails: { type: "Spirii" },
  },
  [SESSION_WITH_NO_MEASUREMENTS.transactionId]: {
    transactionId: SESSION_WITH_NO_MEASUREMENTS.transactionId,
    isCompleted: true,
    startedAt: "2026-06-01T22:40:00.000Z",
    endedAt: "2026-06-02T04:05:00.000Z",
    consumedInWattHours: 24_900,
    tagIdLabel: SESSION_WITH_NO_MEASUREMENTS.tagIdLabel,
    customerName: COMPANY_NAMES.pendingClean,
    location: { id: 4022, name: "Odense Syd" },
    consumed: 24.9,
    createdAt: "2026-06-01T22:35:00.000Z",
    sessionId: "8b2d7e64-1a33-4c88-b7de-5c9a0f4e2b11",
    isPriority: false,
    duration: { charging: 19500, idle: 300 },
    price: { amount: 61.25, currency: "DKK" },
    meterStart: "2400",
    meterStop: "2425",
    lastMeter: "2026-06-02T04:05:00.000Z",
    maxPower: 11,
    avgPower: 4.6,
    vehicleState: { firstValue: 41, lastValue: 78 },
    co2: 0.004,
    evseId: "DK*SPI*E4022*2",
    operatorName: "Spirii Operator",
    company: { name: COMPANY_NAMES.pendingClean },
    auth: {
      type: "RFID",
      idTag: {
        id: 7715,
        uid: "04B2C3D4E5F607",
        operator: { name: "Spirii" },
      },
    },
    roamingDetails: { type: "Spirii" },
  },
  [SESSION_WHOSE_CHART_FAILS.transactionId]: {
    transactionId: SESSION_WHOSE_CHART_FAILS.transactionId,
    isCompleted: true,
    startedAt: "2026-06-05T11:05:00.000Z",
    endedAt: "2026-06-05T12:20:00.000Z",
    consumedInWattHours: 9_100,
    tagIdLabel: SESSION_WHOSE_CHART_FAILS.tagIdLabel,
    customerName: COMPANY_NAMES.pendingClean,
    location: { id: 4023, name: "Vejle Vest" },
    consumed: 9.1,
    createdAt: "2026-06-05T11:00:00.000Z",
    sessionId: "c3e5a917-9d40-4f2b-8a61-0e7b4d3c5f22",
    isPriority: false,
    duration: { charging: 4500, idle: 0 },
    price: { amount: 22.4, currency: "DKK" },
    meterStart: "3100",
    meterStop: "3110",
    lastMeter: "2026-06-05T12:20:00.000Z",
    maxPower: 22,
    avgPower: 7.3,
    vehicleState: { firstValue: 55, lastValue: 71 },
    co2: 0.001,
    evseId: "DK*SPI*E4023*1",
    operatorName: "Spirii Operator",
    company: { name: COMPANY_NAMES.pendingClean },
    auth: {
      type: "RFID",
      idTag: {
        id: 7716,
        uid: "04C3D4E5F60718",
        operator: { name: "Spirii" },
      },
    },
    roamingDetails: { type: "Spirii" },
  },
};

export {
  SEEDED_CHART_SUMMARY,
  SEEDED_CHARGE_RECORDS,
  SEEDED_METER_DATA,
  SEEDED_PRIORITY_TRANSACTIONS,
};
export type { MeterDatum };
